import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {UserGroupHierarchyBO} from "./UserGroupHierarchyBO";
import {esWB_MasterData_Set, esWB_User_Group_Hierarchy} from "../PA.Core/PAdbSchema";
import {WB_MasterDataSetRow} from "../PA.Core/PAdbSchemaRows";


export class UserGroupHierarchyBOValidations {


    static async Validate(aBO: UserGroupHierarchyBO): Promise<void> {


        try{

            if (_.isEmpty(aBO.WB_UserGroupHierarchy.cif.USRGRPH_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Emptyid',
                        type: MessageType.Error,
                        title: "User Group Hierarchy ID cannot be empty.",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('Emptyid')
            }
            if (_.isEmpty(aBO.WB_UserGroupHierarchy.cif.USRGRPH_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Emptyname',
                        type: MessageType.Error,
                        title: "User Group Hierarchy Name cannot be empty.",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('Emptyname')
            }


            let mdset= await aBO.dbContext.find(esWB_MasterData_Set,aBO.WB_UserGroupHierarchy.cif.WB_MDSET_ID)

            // duplicate User Group Hierarchies
           let results= await aBO.dbContext.findAll(esWB_User_Group_Hierarchy,
                {where:{
                        WB_USRGRPH_ID: {neq:aBO.WB_UserGroupHierarchy.cif.WB_USRGRPH_ID},
                        USRGRPH_ID: aBO.WB_UserGroupHierarchy.cif.USRGRPH_ID,
                        WB_MDSET_ID: aBO.WB_UserGroupHierarchy.cif.WB_MDSET_ID,
                        DELETED_IND: {neq: '1'}
                    }
                })

                    if(results.length> 0){
                        aBO.ValidateMessageProvider.addMessage(
                            {
                                code: 'duplicateID',
                                type: MessageType.Error,
                                title: "User Group Hierarchy ID already exists in selected Master Data Set '"+mdset?.MDSET_NAME+"'.",
                                description: "",
                                subtitle: "",
                                count: 0
                            })
                    } else {
                        aBO.ValidateMessageProvider.removeMessage('duplicateID')
                    }

        return
        }
        catch(err) {
            console.log(err)
        }
    }

}
